import { useCallback, useEffect, useState } from 'react';
import { getFabricTemplates } from '../../api/fabricTemplate.api';
import { hydrateFabricTemplate } from './templates';

/**
 * Loads fabric templates from the API.
 * An empty list is valid (e.g. after admin deletes all) — do not fall back to static seeds.
 */
export function useFabricTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const rows = await getFabricTemplates();
      setTemplates((rows || []).map(hydrateFabricTemplate).filter(Boolean));
    } catch (err) {
      console.error('Failed to load fabric templates:', err);
      setError(err);
      setTemplates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { templates, loading, error, refresh, setTemplates };
}
